import React from 'react';
import { Icon } from '@chargify/icons';

import Heading from '../../atoms/Heading';

import { Container, IconContainer } from './ToastMessage.styles';

import { MESSAGE_ICON } from './constants';
import { Size, ColorVariant, MessageType } from './types';

export type ToastMessageProps = {
  /**
   * Toast message
   */
  message: string;
  /**
   * Component size
   */
  size?: Size;
  /**
   * Theme color variant
   */
  colorVariant?: ColorVariant;
  /**
   * Type of message
   */
  type?: MessageType;
};

/**
- The Toast component provides push messages for user actions.
**/
const ToastMessage = ({
  size = 'regular',
  colorVariant = 'dark',
  type = 'info',
  message,
}: ToastMessageProps) => (
  <Container
    size={size}
    gridGap={5}
    colorVariant={colorVariant}
    role="alert"
    aria-live="assertive"
    aria-atomic="true"
  >
    <IconContainer iconColor={`${colorVariant}-${type}`}>
      <Icon fill="inherit" type={MESSAGE_ICON[type]} size={32} />
    </IconContainer>
    <Heading variant="h4" color="inherit">
      {message}
    </Heading>
  </Container>
);

export default ToastMessage;
